
export const extractDomainSelect = (state,domain)=>{
    return state['admin']&&  (state['admin'][domain] || [])
}